import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  cmsOwnerId: belongsTo('user', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  categoryId: belongsTo('category', { inverse: null }),
  audioplayer: belongsTo('audioplayer', { inverse: 'audioplayerShops' }),
});
